// extracted by mini-css-extract-plugin
module.exports = {"desktop-s":"(min-width: 1024px)","tablet":"(min-width: 768px)","grid":"card-grid_grid__M4Wkt"};